import { createApp } from 'vue';
import './style.css';
import { createPinia } from 'pinia';
import { router } from './router';
import { i18n } from './i18n';
import App from './App.vue';
import clickOutside from '@/directives/clickOutside';
import { useAccountStore } from '@/store/AccountStore';

const pinia = createPinia();
const app = createApp(App);

app.directive('click-outside', clickOutside);

app.use(pinia);

const accountStore = useAccountStore();
i18n.global.locale.value = accountStore.profile.language as 'en-US' | 'sv-SE';

app.use(router);
app.use(i18n);

app.mount('#app');
